import type { AppDispatch } from "index";
import {
  emailBuilderCancelPendingAutosave,
  emailBuilderLoad,
} from "redux/actions/emailBuilder/emailBuilder";
import type { TEmailBuilderWorkspace } from "./emailBuilderWorkspace";

export async function emailBuilderReloadFromConflict(
  dispatch: AppDispatch,
  workspace: TEmailBuilderWorkspace,
): Promise<void> {
  dispatch(emailBuilderCancelPendingAutosave());
  await dispatch(emailBuilderLoad(workspace));
}
